export const EMAIL_EDITOR_MODULES = { toolbar: [['bold', 'italic', 'underline'], ['link'], ['clean']] };
export const EMAIL_EDITOR_FORMATS = ['bold', 'italic', 'underline', 'link'];

export const TRAILING_TOKEN = /\{\{[^}]*\}\}$/;

export const TOKEN_RE = /(\{\{[^}]*\}\})/g;

export const getUnknownTokens = (message, variables) => {
    const allowed = new Set((variables || []).map((v) => v.key));
    const matches = (message || '').match(/\{\{[^}]*\}\}/g) || [];
    return matches.filter((m) => !allowed.has(m.slice(2, -2)));
};

const normalizeQuillHtml = (html) => (html || '')
    .replace(/<p><br><\/p>/g, '<br>')   // an empty Quill paragraph *is* one blank line
    .replace(/<\/p>/g, '<br>')            // every paragraph end becomes a line break
    .replace(/<p>/g, '')                  // paragraph starts are now redundant
    .replace(/<br>$/, '');                // drop the trailing break left by the final </p>

// Markup none of EMAIL_EDITOR_FORMATS can represent — a pasted email template lands here.
export const BEYOND_QUILL = /<(table|thead|tbody|tr|t[dh]|img|div|center|h[1-6]|ul|ol|li)\b|style\s*=/i;

// Flatten Quill's <p> wrapping to <br>, but keep hand-written html as typed — told apart by the markup itself.
export const normalizeEmailHtml = (html) => (BEYOND_QUILL.test(html || '') ? (html || '') : normalizeQuillHtml(html));
